import React, { useState, CSSProperties, memo, useCallback } from "react";
import { RiPencilFill } from "react-icons/ri";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaEye, FaPlus } from "react-icons/fa";
import OrganizationCustomerRecordModal from "../Modal/OrganizationCustomerRecordModal";
import { useOutletOrganizationList } from "../hooks/useCustomer";
import { useNavigate } from "react-router-dom";

interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

const TableButton: React.FC<TableButtonProps> = memo(
  ({ onClick, title = "Add Heads", style }) => {
    const defaultStyle: CSSProperties = {
      display: "flex",
      borderRadius: "20px",
      padding: "2px",
      width: "110px",
      height: "40px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
    };

    return (
      <div>
        <button
          onClick={onClick}
          className="btn btn-info"
          style={{ ...defaultStyle, ...style }} // External styles override default
        >
          <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
        </button>
      </div>
    );
  }
);


const TableColumns = (
  handleEdit: (row: any) => void,
  handleManage: (row: any) => void
) => [
  {
    name: "Org Unit",
    selector: (row: { OrgUnitName: string }) => row.OrgUnitName,
  },
  {
    name: "Town",
    selector: (row: { TownName: string }) => row.TownName,
  },
  {
    name: "Visit Fq",
    selector: (row: { VisitFq: string | number }) => row.VisitFq,
  },
  {
    name: "Tags",
    selector: (row: { Tags: number }) => row.Tags,
    wrap:true
  },
  {
    name: "Comments",
    selector: (row: { Comments: string }) => row.Comments,
    wrap: true,
  },

  {
    name: "Actions",
    width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary"
          onClick={() => handleEdit(row)}
          style={{ borderRadius: "20px", padding: "2px", width: "80px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>

        <button
          className="btn btn-info"
          onClick={() => handleManage(row)}
          style={{ borderRadius: "20px", padding: "2px", width: "80px" }}
        >
          {/* <FaEye size={18} style={{ fill: "#fff" }} /> */}
          Manage
        </button>
      </div>
    ),
  },
];

const OrganizationCustomerRecord = ({ OutletId,employeeData }: any) => {
  // console.log('employee ka data', employeeData)
  const [isModal, setIsModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [mode, setMode] = useState<"add" | "edit">("add");
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [limitState, setLimitState] = useState({
    limit: 10,
  });
  const [search, setSearch] = useState({
    searchValue: "",
  });

  const { data: getOutletOrgList } = useOutletOrganizationList({
    outletId: OutletId,
    enabled: !!OutletId,
    params: {
      page: pageState.page,
      limit: limitState.limit,
      search: search.searchValue,
    },
  });

  // console.log("getOutletOrgList", getOutletOrgList?.data?.OutletOrgData);
  const navigate = useNavigate();

  const handleEdit = (row: any) => {
    setIsModal(true);
    setMode("edit");
    setSelectedRow(row);
  };
  const handleManage = (row: any) => {
    navigate('/customer/CustomerOrg',{state:{OrgSelectedData:{...row,employeeData}}});
    setSelectedRow(row);
  };

  const toggle = () => {
    setIsModal(!isModal);
  };

  const handleAddUnit = useCallback(() => {
    setMode("add");
    setIsModal(true);
  }, []);

  const modalClose = () => {
    setIsModal(false);
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
    setLimitState((prevState: any) => {
      return {
        ...prevState,
        limit: limit,
      };
    });
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  };
  return (
    <>
      <BasicDataTable
        paginationTotalRows={getOutletOrgList?.data?.Pagination?.TotalOrgData}
        Title="Origanization Customer Record"
        columns={TableColumns(handleEdit, handleManage)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        data={getOutletOrgList?.data?.OutletOrgData || []}
        headerContent={
          <TableButton
            onClick={() => handleAddUnit()}
            title="Add unit"
            style={{ marginRight: "8px", width: "100px", height: "34px" }}
          />
        }
      />
      <RouteModal
        size="lg"
        toggle={toggle}
        isOpen={isModal}
        title={mode == "add" ? "Add Outlet Org" : "Edit Outlet Org"}
        content={
          <OrganizationCustomerRecordModal
            mode={mode}
            modalClose={modalClose}
            OutletId={OutletId}
            {...(mode !== "add" && selectedRow ? { selectedRow } : {})}
          />
        }
      />
    </>
  );
};
export default OrganizationCustomerRecord;
